import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=72896bf9&scoped=true&"
import script from "./Sale.vue?vue&type=script&lang=js&"
export * from "./Sale.vue?vue&type=script&lang=js&"
import style0 from "./Sale.vue?vue&type=style&index=0&id=72896bf9&prod&lang=css&"
import style1 from "./Sale.vue?vue&type=style&index=1&id=72896bf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72896bf9",
  null
  
)

export default component.exports